onLoad(($) => {
  const nodes = $('.JS-calculate-value-by-tax');

  if (!nodes.length) return;

  const parseNumber = (value) => {
    if (value == null || value === '') return NaN;
    if (window.Masks?.parseBrazilianMoney) {
      return Masks.parseBrazilianMoney(value);
    }
    return parseFloat(String(value).replace(/\./g, '').replace(',', '.'));
  };

  const formatResult = (num, $field) => {
    const decimalPlaces = (window.Masks && $field?.length)
      ? Masks.brlMoneyDecimalPlaces($field)
      : 2;

    if (window.Masks?.formatBrazilianMoney) {
      return Masks.formatBrazilianMoney(num, decimalPlaces);
    }

    return num.toFixed(decimalPlaces).replace('.', ',');
  };

  const calculate = (quantity, valueField, field) => {
    const $field = $(field);
    const quantityNum = parseNumber(quantity);
    const taxNum = parseNumber(valueField.val());

    if (!Number.isNaN(quantityNum) && !Number.isNaN(taxNum) && quantity !== '' && valueField.val() !== '') {
      $field.val(formatResult(quantityNum * taxNum, $field));
    } else {
      $field.val('');
    }
  };

  for (let i = 0; i < nodes.length; i += 1) {
    const node = nodes[i];
    const valueId = $(`#${node.dataset.valueId}`);
    const resultId = $(`#${node.dataset.resultId}`);

    calculate($(node).val(), valueId, resultId);

    $(node).on('change keyup blur', function () {
      calculate($(this).val(), valueId, resultId);
    });

    valueId.on('change keyup blur', function () {
      calculate($(node).val(), $(this), resultId);
    });
  }
});
